// extracted by mini-css-extract-plugin
export default {"btn_b":"btn-border_btn_b__lqV2R","stretch":"btn-border_stretch__EkokZ"};